module.exports = __webpack_public_path__ + "img/example-teacher-parent-meeting.93c47f79.webp";